export type HeroCta = {
	label: string;
	href: string;
};

export type HeroBadge = {
	text: string;
	href?: string;
};

export type HeroBaseProps = {
	title: string;
	subtitle?: string;
	badge?: HeroBadge;
	cta?: HeroCta;
	secondaryCta?: HeroCta;
};

export type HeroImageBackgroundProps = HeroBaseProps & {
	imageUrl: string;
	imageAlt?: string;
};

export const heroDefaults = {
	title: "Your Headline Goes Here",
	subtitle:
		"A compelling description that explains the value proposition and encourages visitors to take action.",
	imageAlt: ""
} satisfies Partial<HeroImageBackgroundProps>;
